import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'

import Icon from 'Pods/Shared/Icon/Icon'

function SuggestJobModal({
  couldDescriptionBeImproved,
  couldPreviewBeImproved,
  primaryAction,
  secondaryAction,
}) {
  const modalOptions = {
    improveDescription: {
      text: `Projects that include comprehensive descriptions typically attract more qualified designers to your
        Project and reduce future miscommunication.`,
      primaryActionTitle: 'Add More Details',
      secondaryActionTitle: 'Publish Project',
    },
    improvePreview: {
      text: 'Reference images typically attract more designers to apply.',
      primaryActionTitle: 'Add Image(s)',
      secondaryActionTitle: 'Publish Project',
    },
    improveBoth: {
      text: `Projects that include reference image(s) and comprehensive descriptions typically attract more
        designers to apply.`,
      primaryActionTitle: 'Edit Project',
      secondaryActionTitle: 'Publish Project anyways',
    },
  }
  let textSet = {}

  if (couldDescriptionBeImproved && couldPreviewBeImproved) {
    textSet = modalOptions.improveBoth
  } else if (couldDescriptionBeImproved) {
    textSet = modalOptions.improveDescription
  } else if (couldPreviewBeImproved) {
    textSet = modalOptions.improvePreview
  }

  return (
    <Modal
      isOpen
      shouldCloseOnOverlayClick
      onRequestClose={primaryAction}
      contentLabel="Modal"
      ariaHideApp={false}
      className={{
        base: '',
        afterOpen: 'overlay-modal--container_after-open overlay-modal-container--xs',
        beforeClose: 'overlay-modal--container_before-close',
      }}
      overlayClassName={{
        base: 'overlay-modal--background',
        afterOpen: 'overlay-modal--background_after-open',
        beforeClose: 'overlay-modal--background_before-close',
      }}
    >
      <div
        className="overlay-modal"
        onClick={(e) => { e.stopPropagation() }}
      >
        <button className="btn btn-transparent overlay-modal--close-inner" onClick={primaryAction}>
          <Icon type={['fal', 'times']} color="grey-dark" />
        </button>
        <div className="overlay-modal--content overlay-modal--jobs">
          <div className="l-inner-large">
            <p className="heading-24">Looks like your Project Description could be improved</p>
            <p className="modal-description">{textSet.text}</p>
            <div className="footer u-text-right u-mt10">
              <button
                className="btn btn-fat btn-outline-default"
                onClick={secondaryAction}
              >
                {textSet.secondaryActionTitle}
              </button>
              <button
                type="submit"
                className="btn btn-fat btn-primary u-ml10"
                onClick={primaryAction}
              >
                {textSet.primaryActionTitle}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

SuggestJobModal.propTypes = {
  couldDescriptionBeImproved: PropTypes.bool.isRequired,
  couldPreviewBeImproved: PropTypes.bool.isRequired,
  primaryAction: PropTypes.func.isRequired,
  secondaryAction: PropTypes.func.isRequired,
}

export default SuggestJobModal
